export const SidebarRow = {
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z Z1',
  round: 'Z',
  cursor: 'pointer',
  transition: 'background 120ms ease',
  background: 'transparent',
  color: 'caption',
  attr: { 'data-sidebar-row': 'true' },
  ':hover': { background: 'overlay' },

  Icon: {
    icon: (el) => el.parent?.icon || 'state',
    boxSize: 'A1 A1'
  },

  Label: {
    tag: 'span',
    fontSize: 'Z2',
    fontWeight: '500',
    flex: '1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    text: (el) => el.parent?.label || ''
  },

  MoreBtn: {
    extends: 'SidebarItemMore'
  }
}
